import get from 'lodash/get';
import { Jurisdiction, EventsToActionsConfig } from './types';

// tslint:disable-next-line no-any
export const getActionData = (context?: { [key: string]: any }, path?: string): any => {
  return context && path ? get(context, path) : undefined;
};

/***
 * wrap setTimeout into named function just to explain purpose of timeout
 * **/
export function nextTick(cb: () => void) {
  setTimeout(cb, 0);
}

export const emptyCallback = () => {}; // tslint:disable-line: no-empty

export const getConfig = (jurisdiction: Jurisdiction): Promise<EventsToActionsConfig> => {
  // ToDo: Phase 2: config should be saved in squiz and fetched from api gateway.
  try {
    if (jurisdiction === Jurisdiction.ES) {
      return import(/*  webpackChunkName: "action_data_es" */ './data/action-data-es/actionData');
    }
    if (jurisdiction === Jurisdiction.IT) {
      return import(/*  webpackChunkName: "action_data_it" */ './data/action-data-it/actionData');
    }

    return import(/*  webpackChunkName: "action_data_com" */ './data/action-data-com/actionData');
  } catch (error) {
    // tslint:disable-next-line
    console.error(error);
    return new Promise((resolve) => resolve({ default: {} }));
  }
};

export const convertQueryStringsObj = (qryStrs: { [q: string]: string } = {}): string => {
  if (!qryStrs || qryStrs === null || Array.isArray(qryStrs) || !Object.keys(qryStrs).length) {
    return '';
  }

  return Object.entries(qryStrs)
    .reduce((acc: string[], [k, v]) => {
      acc.push(`${k}=${v}`);
      return acc;
    }, [])
    .join('&');
};
